import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

const supabaseApi = createApi({
  reducerPath: "supabase",
  baseQuery: fakeBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (build) => ({}),
});

export default supabaseApi;
